import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { useQuery } from '@tanstack/react-query'
import { FilterOptionResponse } from '../types'

const fetchFilterOptionPolicyGroup = async () => {
  const response = await httpClientPrivate.get<FilterOptionResponse[]>(
    `${config.restUrl}/v1/backoffice/e-claim/filter-option/policy-group`,
  )

  return response.data
}

const useFilterOptionPolicyGroup = () => {
  const queryKey = ['useFilterOptionPolicyGroup']
  const queryFn = async () => fetchFilterOptionPolicyGroup()
  const queryResult = useQuery({ queryKey, queryFn })

  return { ...queryResult }
}

export { fetchFilterOptionPolicyGroup, useFilterOptionPolicyGroup }
